import { z } from 'zod'

export const payoffBarrierStepSchema = z.number().nullable()
